// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainPVQContainer {
  border-radius: 0.5rem;
  border: 1px solid #DCDFE1;
  padding: 0.5rem;
}
.mainPVQContainer .header {
  display: flex;
  align-items: center;
  justify-content: start;
  border-bottom: 1px solid #DCDFE1;
  padding: 0.5rem;
}
.mainPVQContainer .header .labelBox {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  padding: 0.3rem 0.5rem;
}

.pieChetContainer {
  width: 355px;
  max-width: 100%;
  margin-top: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/ResutTest/PVQ/pvq.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,yBAAA;EACA,eAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,gCAAA;EACA,eAAA;AACR;AACQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;AACZ;;AAIA;EACI,YAAA;EACA,eAAA;EACA,gBAAA;AADJ","sourcesContent":[".mainPVQContainer{\n    border-radius: 0.5rem;\n    border: 1px solid #DCDFE1;\n    padding: 0.5rem;\n\n    .header {\n        display: flex;\n        align-items: center;\n        justify-content: start;\n        border-bottom: 1px solid #DCDFE1;\n        padding: 0.5rem;\n\n        .labelBox {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            border-radius: 0.5rem;\n            padding: 0.3rem 0.5rem;\n        }\n    }\n}\n\n.pieChetContainer {\n    width: 355px;\n    max-width: 100%;\n    margin-top: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
